module.exports = __webpack_public_path__ + "static/Cross-Jurisdiction 3-fdd3da3200b432b31a2ca06283c24a2d.png";